import { render, staticRenderFns } from "./kpi-d.vue?vue&type=template&id=dec93a32&scoped=true"
import script from "./kpi-d.vue?vue&type=script&lang=ts"
export * from "./kpi-d.vue?vue&type=script&lang=ts"
import style0 from "./kpi-d.vue?vue&type=style&index=0&id=dec93a32&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec93a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec93a32')) {
      api.createRecord('dec93a32', component.options)
    } else {
      api.reload('dec93a32', component.options)
    }
    module.hot.accept("./kpi-d.vue?vue&type=template&id=dec93a32&scoped=true", function () {
      api.rerender('dec93a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/kpi-d/kpi-d.vue"
export default component.exports